export type Unsubscribe = () => void;

/**
 * Minimal gözlemlenebilir durum kutusu. Framework yok; bileşenler
 * subscribe olur, SmgElement bağlantı kopunca aboneliği bırakır.
 */
export class Store<T> {
  private listeners = new Set<(value: T) => void>();

  constructor(private value: T) {}

  get(): T {
    return this.value;
  }

  set(next: T): void {
    if (Object.is(next, this.value)) return;
    this.value = next;
    for (const fn of [...this.listeners]) fn(this.value);
  }

  /** Kısmi güncelleme — obje state'ler için. */
  patch(partial: Partial<T>): void {
    this.set({ ...this.value, ...partial });
  }

  subscribe(fn: (value: T) => void): Unsubscribe {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
}
